import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, Validators } from '@angular/forms';

@Directive({
  selector: '[wooMaxValidator]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: WooMaxValidator,
      multi: true,
    },
  ],
})
export class WooMaxValidator implements Validator {
  @Input('wooMaxValidator') max: number;

  validate(c: AbstractControl): ValidationErrors {
    return Validators.max(this.max)(c);
  }
}
